<template>
  <div class="animated fadeIn">
    <basic-heading title="New Staff">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'add staff'">
      <template #gated-content>
        <staff-form @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import StaffForm from "@/components/lab/staff/StaffForm";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { staffNotifications } from "@/shared/notifications";

const StaffRepository = LabRepositoryFactory.get("staff");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "StaffAdd",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    StaffForm,
  },
  mixins: [ToastNotifications],
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/staff",
            title: "Staff list",
          },
        ],
      };
    },
  },
  methods: {
    async submit(form_data) {
      try {
        const { data } = await StaffRepository.create(form_data);

        this.addSuccess();
        this.$router.push(`/staff/${data.id}`);
      } catch ({ response }) {
        const { status, data } = response.response;

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        });
      }
    },
  },
  notifications: staffNotifications,
};
</script>
